// extracted by mini-css-extract-plugin
module.exports = {"picks":"Picks_picks__3mIm2","products":"Picks_products__2Yx2u","title":"Picks_title__2nqeh","type":"Picks_type__MHEjf","underline":"Picks_underline__3ozIU"};